import { AxiosResponse } from 'axios';
import {
    getDefaultHeaders,
    instance as axiosInstance,
    withHeaders,
} from '../core';

export const getSortedDataWithUrl = async (
    url: string,
    token: string
): Promise<AxiosResponse<any, any>> => {
    const headers = getDefaultHeaders(token);
    const response = await axiosInstance().get(url, withHeaders(headers));
    if (response.data.length) {
        response.data.sort((a: any, b: any) => {
            return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        });
        return response;
    } else {
        return response;
    }
};
